module.exports = __webpack_public_path__ + "img/11.879c625d.jpg";